enum ActionTypes {
  SET_FOOTER_BACKGROUND = 'nextiq/Shared/Footer/SET_FOOTER_BACKGROUND',
}

export default ActionTypes;